import { CreateCampaignDialogController } from './create-campaign-dialog.controller'

function createCampaignDialog () {
  return {
    restrict: 'E',
    templateUrl: '/campaigns/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
    controller: CreateCampaignDialogController
  }
}

export { createCampaignDialog }
